const captchaTokenAsContext = (captchaToken: string) => ({
    context: {
        headers: {
            'X-Verify-Token': captchaToken
        }
    }
})

export { captchaTokenAsContext }
